import * as c from "../utils/constants/constants";

export const forceLogout = () => {
      if(c.SSO === 'true')
        window.location.pathname = '/ssoRedirect';
      else
        window.location.pathname = '/';
      return;
}